import store from '@/store';
import { decode } from 'jsonwebtoken';
import { setStorage } from '@/utils/storage';
import { QWebChannel } from 'qwebchannel';

interface Channel {
  objects: {
    context: {
      [contextKey: string]: any;
    }
    [namespaceKey: string]: {
      [key: string]: any;
    };
  };
}

// 设置完 token 后，直接无密码登录（给 qt 应用使用）
export function setUserToken(token: string) {
  const tokenStr = token.substring('Bearer'.length);
  const tokenInfo = decode(tokenStr) as any;
  setStorage('token', token);
  setStorage('expire', tokenInfo.exp * 1000);
  setStorage('userInfo', tokenInfo.data);
  store.dispatch('login/loginWithToken');
}

// 调用 qt 提供的方法
export function qtWebChannel(message: string) {
  QWebChannel(window.qt.webChannelTransport, (channel: Channel) => {
    const qtWebObj = channel.objects.TinttexViewer;
    qtWebObj.page_invoke_test(message);
  });
}
